<template>
    <div class="tab-account-setting">
        <div class="blockcont">
            <div class="smalltitle">Identify Proofing</div>
            <div class="explain">
                <em>Identity proofing (IDP) is the process of verifying that a person is who he or she
                    claims to
                    be. In order to get accessed to WikiAllergies EMR and to send electronic prescription,
                    user
                    is required to upload copies of his or her driver license, active medical license and an
                    active DEA license if prescribing controlled substances. User is also required to enter
                    a
                    valid credit card to have 1 time charge of a nominal $1.10 as an extra layer of ID
                    proofing.
                    Credit card number is not stored during this verification process. Uploaded driver
                    license
                    is not viewable from this page.</em>
                <em>Once ID proofing process is completed, user can choose to delete the copy of the diver
                    license. This would remove all copies of driver license from WikiAllergies database.
                    Wikiallergies does not store this information.</em>
            </div>
            <div class="clearfix"></div>
            <div class="currentlist">
                <ul class="itemlisttable providerlist">
                    <li class="itemlisthead">
                        <div style="width: 45%!important;">File name</div>
                        <div style="width: 15%!important;">Date</div>
                        <div style="width: 20%!important;">Type</div>
                        <div style="width: 10%!important;">Status</div>
                        <div style="width: 10%!important;text-align: right;padding-right: 5px"></div>
                    </li>
                    <li style="text-align: center" v-if="listFileProofing.length === 0">No documents
                    </li>
                    <li v-for="item in listFileProofing">
                        <div style="width: 45%!important;padding-top: 10px" :title="item.fileName">
                            <a v-if="!item.deleted_at" href="javascript:void(0);" @click="showFile(item)">{{item.fileName}}</a>
                            <span v-if="item.deleted_at">File deleted</span>
                        </div>
                        <div style="width: 15%!important;">{{formatTime(item.created_at)}}</div>
                        <div style="width: 20%!important;">
                            {{item.kindText}}
                        </div>
                        <div style="width: 10%!important;" :title="item.status === 2 ? item.reason_cancel : ''">{{ item.statusText }}
                        </div>
                        <div class="itemaction" style="width: 10%!important;text-align: right;padding-right: 5px">
                        </div>

                    </li>
                </ul>
            </div>
            <preview-pdf
                    v-if="previewPdf.modal"
                    :linkPreview="previewPdf.link"
                    @updateModal="previewPdf.modal = $event">
            </preview-pdf>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>

import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'
import PreviewPdf from '../../../../global/PreviewPdf'
export default {
  name: 'TabAccountSetting',
  components: { PreviewPdf },
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      listFileProofing: [],
      previewPdf: {
        modal: false,
        link: ''
      }
    }
  },
  computed: {},
  watch: {},
  updated () {},
  mounted () {
    this.getDataIdProof()
  },
  beforeDestroy () {},
  methods: {
    showFile (item) {
      if (!item || item.deleted_at) {
        return
      }
      this.previewPdf.link = item.link
      this.previewPdf.modal = true
    },
    async getDataIdProof () {
      try {
        let params = { userId: this.userInfo.id }
        let response = await httpClient.get(`/users/doctor/list-id-proof`, { params: params })
        if (response.data.s === 200) {
          this.listFileProofing = response.data.data.files
        }
      } catch (e) {
        console.log(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
